export const hasUnlinkSubjectIds = (
  subjectId: unknown,
  arenaId: unknown,
): subjectId is number =>
  Number.isInteger(subjectId) &&
  Number(subjectId) > 0 &&
  Number.isInteger(arenaId) &&
  Number(arenaId) > 0;
